import { Injectable } from '@angular/core';
import { WindowRef } from './window-ref';

@Injectable({ providedIn: 'root' })
export class WindowTasksService {

  public open = new Map<string, WindowRef>();

}
